import React from 'react';
import AActivityIndicator from 'antd-mobile/lib/activity-indicator';



export default class ActivityIndicato extends AActivityIndicator {}
